import { OverflowTooltip } from '@/common/components/ui/OverflowTooltip';
import { formatNumber } from '@/common/utils/formatNumber';
import { isFiniteNumber } from '@/common/utils/number';

export const NumericCell = ({ value }: { value?: number }) =>
  isFiniteNumber(value) && <OverflowTooltip>{formatNumber(value)}</OverflowTooltip>;
